import styled from "@emotion/styled"
import { PHeading } from "@porsche-design-system/components-react"
import { spacingStaticSm, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { FormattedMessage } from "react-intl"
import { Skeleton } from "../../skeleton"
import { editableEquipmentListMessages } from "./editableEquipmentList.messages"

export const EditableEquipmentListSkeleton = () => (
	<>
		<StyledHeading size="md">
			<FormattedMessage {...editableEquipmentListMessages.otherEquipmentTitle} />
		</StyledHeading>
		<Skeleton.Table
			caption="Editable Equipment List"
			headings={[
				editableEquipmentListMessages.equipmentName,
				editableEquipmentListMessages.equipmentCode,
				editableEquipmentListMessages.equipmentCategory,
				undefined,
			]}
			rows={10}
		/>
	</>
)

const StyledHeading = styled(PHeading)`
	padding: ${spacingStaticMd} 0 ${spacingStaticSm};
`
